import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { DemoBar, Footer, Nav } from './components/Chrome';
import { DataProvider } from './data/DataContext';
import { brand, useSnapshot } from './lib';
import { AgentPage } from './pages/AgentPage';
import { Dashboard } from './pages/Dashboard';
import { Landing } from './pages/Landing';

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function TitleManager() {
  const { config } = useSnapshot();
  const { name } = brand(config);
  useEffect(() => {
    document.title = `${name} · four AI agents, one self-improving treasury`;
  }, [name]);
  return null;
}

export function App() {
  return (
    <DataProvider>
      <div className="app">
        <TitleManager />
        <Nav />
        <DemoBar />
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/agent/:id" element={<AgentPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Footer />
      </div>
    </DataProvider>
  );
}
